module.exports = __webpack_public_path__ + "static/media/academyIcons.df01e33d.svg";